module.exports = __webpack_public_path__ + "img/icon-trash.d28b3a73.svg";